"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorisedPersonFormDisplaySettingsPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formFieldPropTypes = require("./formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AuthorisedPersonFormDisplaySettingsPropTypes = exports.AuthorisedPersonFormDisplaySettingsPropTypes = {
  readonlyMode: _propTypes.default.bool,
  authorisedPersonPanelToggleRadios: _propTypes.default.shape(_formFieldPropTypes.RadioPropTypes),
  authorisedPersonFirstNameInput: _propTypes.default.shape(_formFieldPropTypes.FormFieldPropTypes),
  authorisedPersonLastNameInput: _propTypes.default.shape(_formFieldPropTypes.FormFieldPropTypes),
  authorisedPersonBirthdateInput: _propTypes.default.shape(_formFieldPropTypes.FormFieldPropTypes)
};